﻿

if (document.body.classList.contains("forside") || document.body.classList.contains("front-page")) {

    $("#logo-image").addClass("light-logo");



}


$(document).ready(function () {
    $(".btn-chevron").on('click', function (event) {

        $('html, body').animate({
            scrollTop: $(".btn-chevron").offset().top + 70
    }, 800, function () {
        });
    });
});